export default {
  Arise: 'Arise',
  System: 'System',
  Required: 'Required',
  EditVersion: 'EditVersion',
  Duplicate: 'Duplicate',
  IsExistDataDepreciation: 'IsExistDataDepreciation',
  AriseOpeningEntry: 'AriseOpeningEntry',
  AriseOpeningEntryOfSpecificAccount: 'AriseOpeningEntryOfSpecificAccount',
};
